module.exports = __webpack_public_path__ + "static/media/default_thumbnail1902_1080.65b89492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail1902_1080.jpg
// module id = 315
// module chunks = 2